<template>
  <span
    v-if="visible"
    class="spinner-border spinner-border-sm mb-1"
    role="status"
    aria-hidden="true"
    style="color: #a6a6a6;"
  ></span>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoadingSpinner",
  props: {
    visible: { type: Boolean, required: false, default: true }
  }
});
</script>
